import React from 'react';
import ProductCard from './ProductCard';
import './ProductCard.css';
import {Link} from 'react-router';

const ProductGrid = ({ products }) => {
    
    const locations = [
        { name: "Kilimambogo", url: "location/Kilimambogo" },
        { name: "Matuu", url: "location/Matuu" },
        { name: "Malindi", url: "location/Malindi" },
    ];
    return (
        <div className="product-grid-container">
            <div className="section-header">
                <h2 className="section-title">We Offer The Best Land Investment Opportunities</h2>
                <p className="section-description">
                We sell prime and affordable plots in {' '} 
                    {locations.map((location, index) => (
                        <>
                            <a
                                href={location.url}
                                className="location-link"
                                key={location.name}
                            >
                                {location.name}
                            </a>
                            {index < locations.length - 1 && ', '}
                        </>
                    ))}
                    . 
                </p>
            </div>
            <div className="product-grid">
                {products.map((product) => (
                    <ProductCard key={product.id} product={product} />
                ))}
            </div>
            <div className="view-more-container">
               <Link to = '/Properties'>
                <button className="view-more-button">Load More</button>
                </Link>
            </div>
        </div>
    );
};

export default ProductGrid;